import { render, staticRenderFns } from "./Inscriptions-dog-datos-comp.vue?vue&type=template&id=5ec2d609&scoped=true&"
import script from "./Inscriptions-dog-datos-comp.vue?vue&type=script&lang=js&"
export * from "./Inscriptions-dog-datos-comp.vue?vue&type=script&lang=js&"
import style0 from "./Inscriptions-dog-datos-comp.vue?vue&type=style&index=0&id=5ec2d609&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec2d609",
  null
  
)

export default component.exports